export enum DoaApproverRole {
    ProjectManager = 'ProjectManager',
    SeniorManager = 'SeniorManager',
}

export const DoaApproverRoleLabels: Record<DoaApproverRole | string, string> = {
    ProjectManager: 'Project Manager',
    SeniorManager: 'Senior Manager',
};
